import { combineReducers } from "redux"
import { setterReducer } from "../common/redux"
import tracker from "../common/tracker"
import * as t from "./actionTypes"
import { captureException } from "../common/error"

export const activeImage = setterReducer("", t.SET_ACTIVE_IMAGE)
export const message = setterReducer("", t.SET_MESSAGE)
export const termModalShown = setterReducer(false, t.SET_TERMS_MODAL_SHOWN)
export const showGinaModal = setterReducer(false, t.SET_SHOW_GINA_MODAL)
export const error = setterReducer("", t.SET_ERROR)
export const errorCode = setterReducer("", t.SET_ERROR_CODE)
const editConfirmNeeded = setterReducer(false, t.SET_EDIT_CONFIRM_NEEDED)
const editConfirmShown = setterReducer(false, t.SET_EDIT_CONFIRM_SHOWN)
const deleteConfirmNeeded = setterReducer(false, t.SET_DELETE_CONFIRM_NEEDED)
export const confirmMessageShown = setterReducer(
  false,
  t.SET_CONFIRM_MESSAGE_SHOWN
)

export const loading = (state = false, action) => {
  switch (action.type) {
    case t.SET_LOADING:
      clearTimeout(window.loadingTimer)
      if (action.loading) {
        window.loadingTimer = setTimeout(() => {
          tracker.longLoad()
          captureException(
            new Error(
              `Loading longer than 15s${
                action.context ? " - " + action.context : ""
              }`
            )
          )
        }, 15000)
      }
      return action.loading
    default:
      return state
  }
}

export const confirmMessage = (state = {}, action) => {
  switch (action.type) {
    case t.SET_CONFIRM_MESSAGE:
      return { ...state, ...action }
    default:
      return state
  }
}

export const editConfirm = combineReducers({
  needed: editConfirmNeeded,
  shown: editConfirmShown,
})

export const deleteConfirm = combineReducers({
  needed: deleteConfirmNeeded,
})



// WEBPACK FOOTER //
// ./assets/interview/reducer.js